import { createSlice } from "@reduxjs/toolkit";
import { closeWizard } from "src/modules/pairing/duck/actions";
import { appRestart } from "src/duck/actions";

const initialState = {
  isRequesting: false,
  responder: null,
  request: null,
  pairingSource: null,
  response: null,
  error: false
};

const pairingRequesterSlice = createSlice({
  name: "pairingRequester",
  initialState,
  reducers: {
    pairingRequested(state, { payload }) {
      state.isRequesting = true;
      state.pairingSource = payload.pairingSource;
      state.responder = payload.responder;
    },
    receivedRequestData(state, { payload }) {
      state.request = payload;
    },
    receivedResponse(state, { payload }) {
      state.response = payload;
    },
    pairingFailed(state) {
      state.error = true;
    },
    resetState() {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(closeWizard, () => {
        return initialState;
      })
      .addCase(appRestart, () => {
        return initialState;
      });
  }
});

export { pairingRequesterSlice };
export default pairingRequesterSlice.reducer;
